import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { DragSource as dragSource } from 'react-dnd';
import { getEmptyImage } from 'react-dnd-html5-backend';

import DnDItemTypes from '../DynamicDnD/DnDItemTypes';

const dragItemsSource = {
  beginDrag(props) {
    const selectedNodes = props.getSelectedTargets();
    props.handleAnswersPreview(selectedNodes);
    return { selectedNodes };
  },
};
function collect(connect, monitor) {
  return {
    connectDragSource: connect.dragSource(),
    connectDragPreview: connect.dragPreview(),
    isDragging: monitor.isDragging(),
  };
}
class DraggableDefinitionAnswer extends Component {
  componentDidMount() {
    // Use empty image as a drag preview so browsers don't draw it
    // and we can draw whatever we want on the custom drag layer instead.
    this.props.connectDragPreview(getEmptyImage(), {
      // IE fallback: specify that we'd rather screenshot the node
      // when it already knows it's being dragged so we can hide it with CSS.
      captureDraggingState: true,
    });
  }

  render() {
    const { connectDragSource, isDragging, name, type } = this.props;
    return connectDragSource(
      <div
        style={{
          opacity: isDragging ? 0.5 : 1,
          backgroundColor: 'transparent',
        }}
      >
        {type ? (
          <span className={type === 'B' ? 'tick-img' : 'hash-img'} />
        ) : (
          ''
        )}{' '}
        {name}
      </div>,
    );
  }
}
DraggableDefinitionAnswer.propTypes = {
  connectDragPreview: PropTypes.func,
  connectDragSource: PropTypes.func.isRequired,
  isDragging: PropTypes.bool.isRequired,
  name: PropTypes.string.isRequired,
  type: PropTypes.string,
};

export default dragSource(
  DnDItemTypes.DnD_ITEM_TYPE_4,
  dragItemsSource,
  collect,
)(DraggableDefinitionAnswer);
